// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","3126":"f65a48b9"}[chunkId] || chunkId) + "." + {"1167":"317924edbf1210254dd5","2937":"81eb816279c55b32c3f0","3126":"22c9450c1a054eb1e881","4991":"defcb6e065e5ac7d9019","5171":"b5928c2af5a2953e983d","9634":"86ea761ec1b3d930f5fa"}[chunkId] + ".js";
};